import { BACKEND_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../../common/js/constants/constants';
import moment from 'moment';
import messages from './exchange-graph-results-lang';
import VueApexCharts from 'vue-apexcharts';
const GRAPH_ASPECT_RATIO = 0.348432;
export default {
	components: {
		VueApexCharts
	},
	data() {
		return {
			options: {},
			height: 0
		};
	},
	props: ['results', 'rateType', 'from', 'to', 'currencyWithName'],
	i18n: { messages },
	computed: {
		dataChanged() {
			return [this.results, this.rateType];
		},
		dateFormat() {
			return DISPLAY_DATE_FORMAT[this.$i18n.locale];
		},
		fromDate() {
			return this.$options.filters.date(this.from, this.dateFormat);
		},
		toDate() {
			return this.$options.filters.date(this.to, this.dateFormat);
		}
	},
	watch: {
		dataChanged() {
			if (!this.results || !this.rateType) {
				return;
			}
			let self = this;
			let graphData = this.results[this.rateType];
			this.options = {
				chart: {
					type: 'area',
					zoom: {
						enabled: false,
						type: 'x'
					},
					toolbar: {
						show: false
					}
				},
				colors: ['#52B030'],
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: 'straight',
					width: 1
				},
				fill: {
					type: 'gradient',
					gradient: {
						shadeIntensity: 1,
						opacityFrom: 1,
						opacityTo: 0,
						stops: [0, 100]
					}
				},
				markers: {
					size: 0,
					hover: {
						size: 6
					}
				},
				xaxis: {
					type: 'datetime',
					labels: {
						formatter: function (value) {
							const diff = moment(self.to, BACKEND_DATE_FORMAT).diff(moment(self.from, BACKEND_DATE_FORMAT), 'months', true);
							if (diff < 1) {
								return moment(value).format('MMM DD, HH:MM');
							} else if (diff <= 3) {
								return moment(value).format('MMM DD');
							} else {
								return moment(value).format('MMM');
							}
						}
					}
				},
				yaxis: {
					title: {
						text: this.$t('yAxis')
					}
				},
				legend: {
					show: false
				},
				tooltip: {
					x: {
						formatter: function (value) {
							return moment(value).format(self.$i18n.locale === 'hu' ? 'YYYY.MM.DD HH:mm' : 'MM/DD/YYYY h:mm a');
						}
					},
					y: {
						formatter: function (val) {
							let rate = self.$t('rate');
							return `${self.results.currencyCode} ${rate}: <b>${val}</b>`;
						}
					},
					marker: {
						show: true
					},
					shared: false,
					followCursor: true,
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						let date = w.globals.seriesX[seriesIndex][dataPointIndex];
						let formattedDate = moment(date).format(self.$i18n.locale === 'hu' ? 'YYYY.MM.DD HH:mm' : 'MM/DD/YYYY h:mm a');
						let rate = self.$t('rate');
						let value = series[seriesIndex][dataPointIndex];
						let color = w.config.colors[seriesIndex];
						return `<div style="font-size:10px;">
									${formattedDate}<br/>
									<span style="color:${color}">●</span>
									<span style="font-size:12px;">${self.results.currencyCode} ${rate}: </span>
									<span style="font-weight:bold;">${value}</span>
								</div>`;
					}
				},
				series: [
					{
						name: `${this.results.currencyCode} ${this.$t('yAxis')}`,
						data: graphData
					}
				]
			};
			this.resizeHandler();
		}
	},
	methods: {
		resizeHandler() {
			this.$nextTick(() => {
				if (this.$refs.container) {
					this.height = this.$refs.container.scrollWidth * GRAPH_ASPECT_RATIO;
				}
			});
		}
	},
	mounted() {
		window.addEventListener('resize', this.resizeHandler);
	},
	onUnmounted() {
		window.removeEventListener('resize', this.resizeHandler);
	}
};
